﻿import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { downloadFile } from "../../api/downloadFile";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { EntityType } from "../../Common.types";

export function getDownloadDocumentVersionUrl(documentId: string, dataId: string, entityType: EntityType, entityId: string) {
    return `/document/${documentId}/${dataId}/data/${entityType}/${entityId}`;
}

export function getDownloadDocumentVersionByVersionId(documentId: string, documentVersionId: string, entityType: EntityType, entityId: string) {
    return `/document/${documentId}/${documentVersionId}/data-from-version/${entityType}/${entityId}`;
}

export function useDotLegalFileUploadDataMapping() {
    const snackBar = useDotLegalSnackbar();

    async function downloadDocument(documentId: string, fileName: string, entityType: EntityType, entityId: string) {
        let url = `/document/${documentId}/data/${entityType}/${entityId}`;

        snackBar.show(createElement(Trans, { i18nKey: "documentIsBeingDownloaded", values: { document: fileName } }));
        await downloadFile(url, fileName);
    }

    async function downloadDocumentVersionByVersionId(
        documentId: string,
        documentVersionId: string,
        fileName: string,
        entityType: EntityType,
        entityId: string
    ) {
        let url = getDownloadDocumentVersionByVersionId(documentId, documentVersionId, entityType, entityId);

        snackBar.show(createElement(Trans, { i18nKey: "documentIsBeingDownloaded", values: { document: fileName } }));
        await downloadFile(url, fileName);
    }

    async function downloadDocumentVersion(documentId: string, dataId: string, fileName: string, entityType: EntityType, entityId: string) {
        let url = getDownloadDocumentVersionUrl(documentId, dataId, entityType, entityId);

        snackBar.show(createElement(Trans, { i18nKey: "documentIsBeingDownloaded", values: { document: fileName } }));
        await downloadFile(url, fileName);
    }

    async function addTaskToCalendar(taskId: string, taskName: string) {
        let url = `/task/${taskId}/addToCalendar`;

        await downloadFile(url, taskName + ".ics");
    }

    return {
        downloadDocument,
        addTaskToCalendar,
        downloadDocumentVersion,
        downloadDocumentVersionByVersionId,
    };
}
